export const FIELD_WIDTHS = {
  default: '100%',
  compact: '160px',
  narrow: '96px',
};

export const FIELD_TAP_TARGETS = {
  compact: 44,
  comfortable: 56,
};

export function resolveFieldWidth(width = 'default') {
  if (typeof width === 'string' && FIELD_WIDTHS[width]) {
    return FIELD_WIDTHS[width];
  }
  return width || FIELD_WIDTHS.default;
}

export function resolveFieldTapTarget(tapTarget = 'compact') {
  if (typeof tapTarget === 'number' && Number.isFinite(tapTarget)) {
    return tapTarget;
  }
  return FIELD_TAP_TARGETS[tapTarget] || FIELD_TAP_TARGETS.compact;
}
